/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitPalAuthSubmissionRequest
 */
export interface SubmitPalAuthSubmissionRequest {
    /**
     * 
     */
    submission_form_data?: { [key: string]: any; };
    /**
     * 
     */
    upload_to_platform?: boolean;
    /**
     * 
     */
    include_lead_summary_report?: boolean;
    /**
     * 
     */
    comment?: string;
    /**
     * Required when submission_mode is efax.
     */
    destination_fax_number?: string;
    /**
     * Override the submission mode at submit time. 'hospital_initiated' prepares a hospital-managed submission. 'efax' sends the generated package through Documo and stores the Documo message id on the PAL submission.
     */
    submission_mode?: SubmitPalAuthSubmissionRequestSubmissionModeEnum;
    /**
     * Carve-outs selected for submission, sent concurrently with this pre-auth. Writes a submission attempt and transitions each to pending, in the same transaction as the pre-auth's own status write.
     */
    carve_out_ids?: Array<string>;
}


/**
 * @export
 */
export const SubmitPalAuthSubmissionRequestSubmissionModeEnum = {
    HospitalInitiated: 'hospital_initiated',
    Efax: 'efax',
} as const;
export type SubmitPalAuthSubmissionRequestSubmissionModeEnum = typeof SubmitPalAuthSubmissionRequestSubmissionModeEnum[keyof typeof SubmitPalAuthSubmissionRequestSubmissionModeEnum];


/**
 * Check if a given object implements the SubmitPalAuthSubmissionRequest interface.
 */
export function instanceOfSubmitPalAuthSubmissionRequest(value: object): value is SubmitPalAuthSubmissionRequest {
    return true;
}

export function SubmitPalAuthSubmissionRequestFromJSON(json: any): SubmitPalAuthSubmissionRequest {
    return SubmitPalAuthSubmissionRequestFromJSONTyped(json, false);
}

export function SubmitPalAuthSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitPalAuthSubmissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'submission_form_data': json['submission_form_data'] == null ? undefined : json['submission_form_data'],
        'upload_to_platform': json['upload_to_platform'] == null ? undefined : json['upload_to_platform'],
        'include_lead_summary_report': json['include_lead_summary_report'] == null ? undefined : json['include_lead_summary_report'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'destination_fax_number': json['destination_fax_number'] == null ? undefined : json['destination_fax_number'],
        'submission_mode': json['submission_mode'] == null ? undefined : json['submission_mode'],
        'carve_out_ids': json['carve_out_ids'] == null ? undefined : json['carve_out_ids'],
    };
}

export function SubmitPalAuthSubmissionRequestToJSON(json: any): SubmitPalAuthSubmissionRequest {
    return SubmitPalAuthSubmissionRequestToJSONTyped(json, false);
}

export function SubmitPalAuthSubmissionRequestToJSONTyped(value?: SubmitPalAuthSubmissionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submission_form_data': value['submission_form_data'],
        'upload_to_platform': value['upload_to_platform'],
        'include_lead_summary_report': value['include_lead_summary_report'],
        'comment': value['comment'],
        'destination_fax_number': value['destination_fax_number'],
        'submission_mode': value['submission_mode'],
        'carve_out_ids': value['carve_out_ids'],
    };
}

